import loadable from '@loadable/component';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RouteChangeCanceler from './RouteChangeCanceler';
import ExamScreen from 'components/exam/ExamScreen';
import NewUpdateExam from 'components/exam/modal/NewUpdateExam';
import SpecialisationMaster from 'components/master-data/SpecialisationMaster';
import ExamTemplate from 'components/exam/ExamTemplate';
import SubjectMaster from 'components/master-data/SubjectMaster';
import CourseList from 'components/master-data/CourseList';
import ConfigurationScreen from 'components/master-data/ConfigurationScreen';
import GenerateQuestion from 'components/exam/modal/GenerateQuestion';
import BackupUpdateExam from 'components/exam/modal/BackupUpdateExam';
import AssociateCandidate from 'components/exam/modal/AssociateCandidate';
import CreateExam from 'components/exam/modal/create-exam-steps/CreateExam';
const ExamPage = loadable(() => import('components/exam/ExamPage'), { fallback: <LoadingIndicator /> });
const ResultTable = loadable(() => import('components/result/ResultTable'), { fallback: <LoadingIndicator /> });
const ViewResult = loadable(() => import('components/result/sub-screens/ViewResult'), { fallback: <LoadingIndicator /> });

const ExamRoute: React.FC = () => {
    return (
        <div>
            {/* <LayoutPage> */}
            <Routes>
                <Route path="/exam/*" element={<ExamPage />} />
                <Route path="/exam/add-exam" element={<BackupUpdateExam />} />
                <Route path='/exam/create-exam' element={<CreateExam />} />
                <Route path='/test-exams' element={<NewUpdateExam/>}/>
                <Route path="/result" element={<ResultTable />} />
                <Route path="/result/view-result" element={<ViewResult />} />
                <Route path='/exam-page' element={<ExamScreen />} />
                <Route path='/specialisation' element={<SpecialisationMaster />} />
                <Route path='/subject' element={<SubjectMaster />} />
                <Route path='/section-template' element={<ExamTemplate />} />
                <Route path='/course-master' element={<CourseList />} />
                <Route path='/configuration' element={<ConfigurationScreen />} />
                <Route path='/generate-question' element={<GenerateQuestion />} />
                <Route path='/exam/associate-candidate' element={<AssociateCandidate />} />
            </Routes>
            {/* </LayoutPage> */}
        </div>
    )
}

export default ExamRoute;